var map = {
	"./p-s4-1.png": "dc0fb",
	"./p-s4-2.png": "afd0",
	"./p-s4-3.png": "25be",
	"./p-s4-4.png": "b907",
	"./p-s4-5.png": "a153",
	"./p-s4-6.png": "df7d",
	"./p-s4-7.png": "41a1",
	"./p-s4-8.png": "9278"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d39";